/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ characters: NonNullable<unknown>, period: NonNullable<unknown> }} Signup_Feature_Pro_4Inputs */

const en_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Machine Translation — ${i?.characters} characters/${i?.period}**`)
};

const fr_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Machine Translation — ${i?.characters} characters/${i?.period}**`)
};

const de_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Machine Translation — ${i?.characters} characters/${i?.period}**`)
};

const it_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Machine Translation — ${i?.characters} characters/${i?.period}**`)
};

const ru_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Machine Translation — ${i?.characters} characters/${i?.period}**`)
};

const es_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Machine Translation — ${i?.characters} characters/${i?.period}**`)
};

const zh_cn2_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Machine Translation — ${i?.characters} characters/${i?.period}**`)
};

const ja_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Machine Translation — ${i?.characters} characters/${i?.period}**`)
};

const hi_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Machine Translation — ${i?.characters} characters/${i?.period}**`)
};

const pt_pt2_signup_feature_pro_4 = /** @type {(inputs: Signup_Feature_Pro_4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Machine Translation — ${i?.characters} characters/${i?.period}**`)
};

/**
* | output |
* | --- |
* | "Machine Translation — {characters} characters/{period}**" |
*
* @param {Signup_Feature_Pro_4Inputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_feature_pro_4 = /** @type {((inputs: Signup_Feature_Pro_4Inputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Feature_Pro_4Inputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_feature_pro_4(inputs)
	if (locale === "de") return de_signup_feature_pro_4(inputs)
	if (locale === "it") return it_signup_feature_pro_4(inputs)
	if (locale === "ru") return ru_signup_feature_pro_4(inputs)
	if (locale === "es") return es_signup_feature_pro_4(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_feature_pro_4(inputs)
	if (locale === "ja") return ja_signup_feature_pro_4(inputs)
	if (locale === "hi") return hi_signup_feature_pro_4(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_feature_pro_4(inputs)
	return en_signup_feature_pro_4(inputs)
});